import { Injectable, isDevMode } from '@angular/core';

import { type Translation, type TranslocoLoader } from '@jsverse/transloco';
import { of, type Observable } from 'rxjs';
import en from './catalogue/en.json' with { type: 'json' };

@Injectable({ providedIn: 'root' })
export class AmpTranslocoLoader implements TranslocoLoader {
  getTranslation(_lang: string): Observable<Translation> {
    if (isDevMode() && _lang !== 'en') {
      console.warn(`AMP i18n: unknown language '${_lang}', using en`);
    }

    return of(en as Translation);
  }
}
